import { Dispatch, RefObject, SetStateAction, createContext } from "react";
import { DinamicFormRefValues, DynamicFormRefValues, DynamicRefRef } from "../../../../../../../../components/dynamicFormRef/types";
import { AnswerFormRef } from "../../question/answer/answerForm";
import { Item } from "../../../../../../../../utils/types/generals";
import { EvidenceActive, OptionActionProps, OptionActionRef, OptionActionSavePayload } from "../../../../../../components/optionActions/types";
import { ConfigType, OptionActionIds, QuestionTree } from "../provider/types";
import { DraggableProvided } from "react-beautiful-dnd";
import { Dayjs } from "dayjs";
import { ModalState } from "../../../../typing/types";

const SectionContext = createContext<{
    onChangeQuestionnaire: ((payload: DynamicFormRefValues | undefined) => void)
    onChangeAnswer: (payload: {
        payload: {
            current: any;
            [x: string]: DynamicFormRefValues;
        };
        id: string;
    }) => void
    questionData?: DynamicFormRefValues
    isOptionType: {
        isSimple: boolean;
        isMultiple: boolean;
        isFree: boolean;
        isAffective: boolean;
        isCatalog: boolean;
    }
    questionTree: QuestionTree | undefined
    loaderTree: boolean
    option: string
    answerListLength: number
    questionTemplate: DinamicFormRefValues
    answerList: any
    idToUpdateQuestionList: string
    totalQuestionPoints: number
    totalSectionPoints: number
    openOptionAction: boolean
    optionActionDefaultValues?: OptionActionProps['defaults']
    optionActionIds: OptionActionIds
    openConfig: (payload: {
        id: Array<string> | null;
        name: ConfigType;
    }) => void
    // setSectionData: Dispatch<SetStateAction<DynamicFormRefValues>>
    // sectionData: DynamicFormRefValues | undefined
    addAnswer: () => void
    saveConfigurations: (payload: OptionActionSavePayload) => void
    answerOrder: (list: any[]) => void
    onBlurAnswer: (payload: {
        payload: {
            current: any;
            [x: string]: DynamicFormRefValues;
        };
        id: string;
    }) => void
    questionOrder: (list: any[]) => void
    arrow: string[]
    saveQuestion: () => void
    keepSafeQuestionData: () => void
    removeQuestion: ({ id }: {
        id: string;
    }) => void
    removeAnswer: ({ id }: {
        id: string;
    }) => void
    refAnswerList: {
        refsByKey: Record<string, AnswerFormRef | null>;
        setRef: (element: AnswerFormRef | null, key: string) => void;
        addRef: (payload: {
            element: AnswerFormRef | null;
            name: string;
        }) => AnswerFormRef | null;
    }
    refQuestion: {
        refsByKey: Record<string, DynamicRefRef | null>;
        setRef: (element: DynamicRefRef | null, key: string) => void;
        addRef: (payload: {
            element: DynamicRefRef | null;
            name: string;
        }) => DynamicRefRef | null;
    }
    refSections: {
        refsByKey: Record<string, DynamicRefRef | null>;
        setRef: (element: DynamicRefRef | null, key: string) => void;
        addRef: (payload: {
            element: DynamicRefRef | null;
            name: string;
        }) => DynamicRefRef | null;
    }
    editQuestion: ({ id }: {
        id: string;
    }) => void
    questionValuePoints: number
    questionId: string
    idToOptionAction: string
    options: Item[]
    optionGroup: Item[]
    questionActionItemList: Item[]
    cancelEdit: () => void
    isGeneral: boolean
    cannotSeeConfig: {
        actionPlan: boolean;
        evidence: boolean;
        reportFolio: boolean;
        reincidence: boolean;
    }
    detailConfig: {
        title?: string | undefined;
        description?: string | undefined;
        id: string[];
        answer?: string | undefined;
    } | undefined
    headerConfig: {
        created: string;
        date: Dayjs;
    }
    setModal: (value: SetStateAction<ModalState>) => void
    sectionAmount: ({ id, questionAmount }: {
        id: string;
        questionAmount: number;
    }) => void
    checkQuestionOrAnswerHaveEvidence: EvidenceActive
    optionRef: RefObject<OptionActionRef>
}>(Object({}))

export { SectionContext }